import { authenticatedFetch, getApiBaseUrl } from '../config/api';

const API_BASE_URL = getApiBaseUrl();

export interface CreditBalance {
  id: string;
  brandId: string;
  availableCredits: number;
  reservedCredits: number;
  lifetimePurchasedCredits: number;
  lifetimeSpentCredits: number;
  currency: string;
}

export interface CreditPackage {
  id: string;
  code: string;
  name: string;
  credits: number;
  priceAmount: number;
  currency: string;
}

export interface CreditTransaction {
  id: string;
  amount: number;
  balanceAfter: number;
  type: string;
  status: string;
  referenceType?: string;
  referenceId?: string;
  createdAt: string;
  featureType?: { code: string; name: string };
}

export interface AdminCreditAdjustmentPayload {
  amount: number;
  reason?: string;
}

export class CreditService {
  static async getBalance(brandId: string): Promise<CreditBalance> {
    const response = await authenticatedFetch(`${API_BASE_URL}/brands/${brandId}/credits/balance`);
    const data = await response.json();
    if (!response.ok || !data.success) throw new Error(data.error || 'Kredi bakiyesi alınamadı');
    return data.balance;
  }

  static async getPackages(): Promise<CreditPackage[]> {
    const response = await authenticatedFetch(`${API_BASE_URL}/credits/packages`);
    const data = await response.json();
    if (!response.ok || !data.success) throw new Error(data.error || 'Kredi paketleri alınamadı');
    return data.packages;
  }

  static async getTransactions(brandId: string): Promise<CreditTransaction[]> {
    const response = await authenticatedFetch(`${API_BASE_URL}/brands/${brandId}/credits/transactions`);
    const data = await response.json();
    if (!response.ok || !data.success) throw new Error(data.error || 'Kredi hareketleri alınamadı');
    return data.transactions;
  }

  static async createPurchase(brandId: string, packageId: string): Promise<{ purchaseId: string; checkoutUrl?: string | null; message?: string }> {
    const response = await authenticatedFetch(`${API_BASE_URL}/brands/${brandId}/credits/purchases`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ packageId, provider: 'iyzico' }),
    });
    const data = await response.json();
    if (!response.ok || !data.success) throw new Error(data.error || 'Satın alma başlatılamadı');
    return data;
  }

  static async adminAdjustCredits(brandId: string, payload: AdminCreditAdjustmentPayload): Promise<CreditBalance> {
    const response = await authenticatedFetch(`${API_BASE_URL}/admin/brands/${brandId}/credits/adjust`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (!response.ok || !data.success) throw new Error(data.error || 'Kredi tanımlanamadı');
    return data.balance;
  }
}

export default CreditService;
